export default __webpack_public_path__ + "static/media/D_rich_food.aadd16c0.svg";